<template>
  <div :style="$cmsStyles('c_36f4087871d8')" class="media-container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="media-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_36f4087871d8', 'f_0001', true)" class="banner-wrapper"></div>
        <div class="common-content-wrapper content-wrapper">
          <div v-show="$cms('c_36f4087871d8', 'f_0002', true)" class="box-1">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_36f4087871d8', 'f_0003', "品牌介绍") }}</h2>
              <div class="box-header-desc">{{ $cms('c_36f4087871d8', 'f_0004', "Brand  Introduction") }}</div>
            </div>
            <div class="box-content">
              <div class="desc">2019年，大嘴鳄由魔筷科技孵化，聚焦肉类预制食品，以“便捷、美味、健康”为核心，瞄准现代家庭快节奏烹饪需求。品牌从烤肠切入，凭借优质供应链与真材实料，打造出爆款火山石烤肠，年销量破亿根。多次荣登快手分销榜榜首，斩获第四届ISEE全球食品创新奖以及亿邦动力新消费峰会TOP50成长性品牌等殊荣。<br />
在深耕烤肠品类、夯实“烤肠专家”形象的同时，大嘴鳄拓展品类至全场景肉制品矩阵，2026年品牌心智升级为“国民烤肠专家“，实现从一根肠到一桌菜的跨越。<br />
未来品牌将以专业与创新，为万千家庭提供便捷美味的肉制品</div>
            </div>
          </div>

          <section v-show="$cms('c_36f4087871d8', 'f_0020', true)" class="box-2" aria-label="大嘴鳄品牌优势">
            <div class="brand-proof-intro">
              <img class="brand-proof-shape" :src="$cms('c_36f4087871d8', 'f_0022', 'https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789720795572997520.png')" alt="" loading="lazy" />
              <img class="brand-proof-logo" :src="$cms('c_36f4087871d8', 'f_0021', 'https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789720795467556613.png')" alt="大嘴鳄" width="156" height="160" loading="lazy" />
              <img class="brand-proof-benefits" :src="$cms('c_36f4087871d8', 'f_0023', 'https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789726036298969780.png')" :alt="$cms('c_36f4087871d8', 'f_0027', '领销量：爆款烤肠年销破亿根，稳居国民烤肠品类TOP1地位；创口味：地域风味与场景定制；适场景：适配烤箱、空气炸锅等多种做法；守品质：坚持好原料与好味道。')" loading="lazy" />
            </div>
            <div class="brand-proof-results">
              <img class="brand-proof-slogan" :src="$cms('c_36f4087871d8', 'f_0028', 'https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789961953379549554.png')" :alt="$cms('c_36f4087871d8', 'f_0025', '饿了馋了就吃大嘴鳄')" width="840" height="212" loading="lazy" />
              <dl class="brand-proof-stats">
                <div v-for="(item, index) in brandProofStats" :key="index" class="brand-proof-stat">
                  <dt>{{ item.label }}</dt>
                  <dd><span class="brand-proof-value">{{ item.value }}</span><span v-if="item.unit" class="brand-proof-unit">{{ item.unit }}</span><sup v-if="item.suffix">{{ item.suffix }}</sup></dd>
                </div>
              </dl>
            </div>
          </section>


          <div v-show="$cms('c_36f4087871d8', 'f_0007', true)" class="box-3">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_36f4087871d8', 'f_0008', "品牌发展") }}</h2>
              <div class="box-header-desc">{{ $cms('c_36f4087871d8', 'f_0009', "Brand Development") }}</div>
            </div>
            <div class="box-content">
              <div class="item" v-for="(item, index) in infoList" :key="index">
                <div class="info">
                  <div class="info-title">{{ item.title }}</div>
                  <div class="info-desc">{{ item.desc }}</div>
                </div>
                <div class="dot-box">
                  <div class="dot"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="box-6" style="background: #f8f8f8;">
            <div class="box-header">
              <h2 class="box-header-title">品牌荣誉</h2>
              <div class="box-header-en-title">Brand Honors</div>
            </div>
            <div class="box-content">
              <img class="img-1" src="https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789720795116918795.png" alt="">
              <img class="img-2" src="https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789720795189263300.png" alt="">
              <img class="img-3" src="https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789721195652727945.jpg" alt="">

            </div>
          </div>

          <div v-show="$cms('c_36f4087871d8', 'f_0010', true)" class="box-7">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_36f4087871d8', 'f_0011', "产品介绍") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_36f4087871d8', 'f_0012', "Product Introduction") }}</div>
              <div class="box-header-desc">{{ $cms('c_36f4087871d8', 'f_0013', "饿了馋了就吃大嘴鳄") }}</div>
            </div>
            <div class="box-content">
              <div class="band-group-list">
                <img class="group-item" src="https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789720795300619377.jpg" alt="">
                <img class="group-item" src="https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789720795326404817.jpg" alt="">
                <img class="group-item" src="https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789955488933630594.jpg" alt="">
              </div>
            </div>
          </div>
          <BrandCooperationBox />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue';
import BrandCooperationBox from '@/components/brand/BrandCooperationBox.vue';

export default {
  components: {
    ToolsBar,
    BrandCooperationBox,
  },
  head() { return this.$cmsHead('c_36f4087871d8', {
    title: '大嘴鳄-新风味家庭方便小吃|火山石烤肠|即食食品|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '大嘴鳄,火山石烤肠,方便小吃,即食食品,战斧鸡腿,香酥牛肉馅饼,秘制黑椒烤鸡,新风味,家庭零食,快手,抖音,视频号,小红书,魔筷科技',
      },
      {
        name: 'Description',
        content:
          '大嘴鳄品牌定位于"打造新风味家庭方便小吃"，连续多年销售额过亿，多次荣登快手快分销榜榜首。主打火山石烤肠等爆款产品，为千万消费者提供卓越的产品和服务体验。',
      },
    ],
  }); },
  data() {
    return {
      brandProofStats: this.$cms('c_36f4087871d8', 'f_0026', [{"value":"5","unit":"亿","suffix":"+","label":"电商渠道年销售额"},{"value":"10","unit":"万","suffix":"+","label":"累计直播电商带货主播"},{"value":"TOP1","unit":"","suffix":"","label":"快手肉禽类目TOP1品牌"}]),
      infoList: this.$cms('c_36f4087871d8', 'f_0014', [{"title":"2019","desc":"大嘴鳄2019年成立"},{"title":"2021","desc":"大嘴鳄火山石烤肠上线"},{"title":"2022","desc":"年售9000万根烤肠"},{"title":"2023","desc":"大嘴鳄品牌开启双十一大牌大补，当天卖出1800万根烤肠，今年将1.2亿+根烤肠送上餐桌"},{"title":"2025","desc":"快手肉禽类目Top3品牌；全网年度GMV规模超过5亿；"}]),
      brandBtns: this.$cms('c_36f4087871d8', 'f_0015', ["全部产品","螺蛳粉系列","地道美食系列","新风味美食系列"]),
      brandGroupList: this.$cms('c_36f4087871d8', 'f_0016', [{"list":[{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000289.17570514390384913.png","name":"火山石烤肠"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000279.17570514390399115.png","name":"香酥牛肉馅饼"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000239.17570514390405004.png","name":"秘制黑椒烤鸡"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039710000968.17570514390412134.png","name":"战斧鸡腿"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000479.17570514390469270.png","name":"韭菜鸡蛋馅饼"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000296.17570514390439640.png","name":"灌蛋油条"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000257.17570514390433865.png","name":"蒸油条"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000119.17570514390428532.png","name":"星星脆鸡排"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000258.17570514390313284.png","name":"蒜香酸辣去骨鸡爪"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000707.17570514390459382.png","name":"冷吃龙虾尾"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000963.17570514390451828.png","name":"椒麻大杂烩"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905135039700000893.17570514390446254.png","name":"冷吃五拼千层肚"}]}]),
    }
  },
  mounted() {
    // this.initFullpage()
    this.$refs.toolsBar.show()
  },
  methods: {
   
  },
}
</script>

<style lang="less" scoped>
@import "../../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-image: var(--cms-c_36f4087871d8-f_0017, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908163056060000692.17573202558444857.jpg?x-oss-process=image/quality,Q_80"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
    }
  }
  .content-wrapper {
    .box-1 {
      background: #FFF;
      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 60);
        .pxToVw(width, 1440);
        .pxToVw(height, 656);
        background-image: var(--cms-c_36f4087871d8-f_0018, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908171429660000227.17573228694585575.png"));
        background-size: contain;
        background-repeat: no-repeat;
        box-sizing: border-box;
        position: relative;
        .pxToVw(padding-top, 190);
        .pxToVw(padding-left, 80);
        .desc {
          .pxToVw(width, 720);
          font-weight: 400;
          .pxToVw(font-size, 22);
          .pxToVw(line-height, 40);
          color: #666666;
        }
      }
    }

    .box-2 {
      background: #fff;
      .brand-proof-intro {
        position: relative;
        z-index: 1;
        .pxToVw(height, 674);
        img {
          position: absolute;
          display: block;
          left: 50%;
          transform: translateX(-50%);
          height: auto;
        }
        .brand-proof-shape {
          .pxToVw(top, 156);
          .pxToVw(width, 1440);
        }
        .brand-proof-logo {
          .pxToVw(top, 80);
          .pxToVw(width, 156);
        }
        .brand-proof-benefits {
          .pxToVw(top, 300);
          .pxToVw(width, 1200);
        }
      }
      .brand-proof-results {
        box-sizing: border-box;
        background-color: #ff7a00;
        background-image: var(--cms-c_36f4087871d8-f_0024, url("https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789720795252875791.jpg"));
        background-position: center;
        background-size: cover;
        .pxToVw(min-height, 464);
        .pxToVw(padding-top, 84);
        .pxToVw(padding-bottom, 76);
        color: #fff;
      }
      .brand-proof-slogan {
        display: block;
        margin: 0 auto;
        .pxToVw(width, 420);
        height: auto;
      }
      .brand-proof-stats {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        margin: 0 auto;
        padding: 0;
        .pxToVw(width, 1100);
        .pxToVw(margin-top, 60);
        .pxToVw(gap, 30);
      }
      .brand-proof-stat {
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        dt {
          order: 1;
          .pxToVw(margin-top, 16);
          .pxToVw(font-size, 18);
          line-height: 1.6;
        }
        dd {
          display: flex;
          justify-content: center;
          align-items: baseline;
          margin: 0;
          line-height: 1;
          white-space: nowrap;
        }
        .brand-proof-value {
          font-family: 'DIN Condensed', 'Arial Narrow', Impact, sans-serif;
          font-weight: 700;
          .pxToVw(font-size, 72);
        }
        .brand-proof-unit {
          .pxToVw(font-size, 38);
        }
        sup {
          align-self: flex-start;
          .pxToVw(margin-top, 12);
          .pxToVw(margin-left, 4);
          .pxToVw(font-size, 20);
        }
      }
    }

    .box-3 {
      background: #FFF;
      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 80);
        .pxToVw(margin-bottom, 0);
        background-image: var(--cms-c_36f4087871d8-f_0019, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250822103558130000636.17558301578043488.jpg"));
        background-size: cover;
        background-repeat: no-repeat;
        .pxToVw(height, 597);
        .pxToVw(width, 1354);
        position: relative;
        .dot-box {
          position: absolute;
          .dot {
            .pxToVw(width, 30);
            .pxToVw(height, 30);
            background: #FFFFFF;
            box-shadow: 0px 2px 10px 0px rgba(255,102,0,0.4);
            position: relative;
            .pxToVw(border-radius, 30);
            &::after {
              content: "";
              background: #FF6600;
              position: absolute;
              border-radius: 50%;
              .pxToVw(width, 14);
              .pxToVw(height, 14);
              .pxToVw(top, 8);
              .pxToVw(left, 8);
            }
          }
        }
        .item {
          position: absolute;
          .pxToVw(width, 240);
          .info-title {
            font-family: DINCond-Light, DINCond;
            .pxToVw(font-size, 42);
            .pxToVw(line-height, 49);
            color: #FF6600;
            font-weight: bold;
          }
          .info-desc {
            font-weight: 300;
            .pxToVw(font-size, 14);
            .pxToVw(line-height, 30);
            color: #666666;
          }
          &:nth-child(1) {
            .pxToVw(top, 390);
            .pxToVw(left, 20);
            .dot-box {
              .pxToVw(top, -50);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(2) {
            .pxToVw(bottom, 286);
            .pxToVw(left, 322);
            .dot-box {
              .pxToVw(bottom, -50);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(3) {
            .pxToVw(top, 345);
            .pxToVw(left, 600);
            .dot-box {
              .pxToVw(top, -50);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(4) {
            .pxToVw(bottom, 420);
            .pxToVw(left, 860);
            .dot-box {
              .pxToVw(bottom, -80);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(5) {
            .pxToVw(top, 132);
            .pxToVw(left, 1164);
            .dot-box {
              .pxToVw(top, -50);
              .pxToVw(left, 30);
            }
          }
        }
      }
    }

    .box-6 {
      .box-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .pxToVw(margin-top, 50);
        img {
          display: block;
        }
        .img-1 {
          .pxToVw(width, 778);
          .pxToVw(height, 76);
        }
        .img-2 {
          .pxToVw(width, 1440);
          .pxToVw(height, 80);
          .pxToVw(margin-top, 40);
          .pxToVw(margin-bottom, 40);
        }
        .img-3 {
          .pxToVw(width, 1440);
          .pxToVw(height, 411);
        }
      }
    }

    .box-7 {
      background: #FFF;
      .pxToVw(padding-bottom, 80);
      .band-btns {
        display: flex;
        justify-content: center;
        .pxToVw(gap, 40);
        .pxToVw(padding-top, 60);
        .pxToVw(padding-bottom, 60);
        .btn {
          .pxToVw(width, 210);
          .pxToVw(height, 48);
          .pxToVw(border-radius, 30);
          .pxToVw(font-size, 18);
          .pxToVw(line-height, 25);
          box-sizing: border-box;
          font-weight: 400;
          color: #333333;
          border: 1px solid #999999;
          display: flex;
          align-items: center;
          justify-content: center;

          &:first-child {
            background: linear-gradient( 90deg, #FF6600 0%, #FC4440 100%);
            border: none;
            color: #fff;
          }
        }
      }

      .box-content {
        display: flex;
      }
      .band-group-list {
        display: flex;
        flex-wrap: wrap;
        .pxToVw(padding-top, 80);
        margin: 0 auto;
        .pxToVw(gap, 30);
        .group-item {
          .pxToVw(width, 400);
        }
      }
    }
  }
}
</style>
